import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { v4 as uuid } from 'uuid';
import { Input } from '../../../components';
import { AddWhite, CloseIcon } from '../../../assets/icons';
import { clone } from '../../../utils';

const ModalCreateSubcategory = ({ onClose, onSuccess, initialData }) => {
  const { form, onAdd, onChange, onRemove, submit } = useForm({ initialData, onClose, onSuccess });

  return (
    <div className="w-[36rem] px-4 bg-white rounded-2xl shadow-xl overflow-hidden max-h-[90vh] overflow-y-auto">
      <div className="flex items-center justify-between py-4">
        <h2 className="text-lg font-bold text-text">{ initialData?.name }</h2>
        <button
          type="button"
          className="p-1.5 rounded-full hover:bg-gray5 transition-colors"
          onClick={onClose}
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-text">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div className="flex items-center justify-between py-4">
        <h2 className="text-lg font-bold text-text">Nueva subcategoría</h2>
        <button onClick={onAdd} className="flex items-center gap-2 bg-green text-white px-4 py-1.5 rounded-lg font-semibold">
          <img src={AddWhite} className="w-4 h-4" alt="" />
          Agregar
        </button>
      </div>

      <div className="space-y-4">
        {form.items.map((item, index) => (
          <Input
            placeholder="Nombre"
            value={item.name}
            onValueChange={v => onChange(item._id, 'name', v)}
            append={
              <button
                type="button"
                tabIndex="-1"
                onClick={() => onRemove(index)}
                className="text-gray-400"
              >
                <img src={CloseIcon} className="w-4 h-4" alt="" />
              </button>
            }
          />
        ))}
      </div>

      <div className="flex justify-center mt-2 px-6 py-4 gap-3">
        <button
          type="button"
          className="px-6 py-2 bg-gray-200 text-text font-semibold rounded-full hover:bg-gray-300 transition-colors text-sm"
          onClick={onClose}
        >
          Cerrar
        </button>
        <button
          type="button"
          className="px-6 py-2 bg-red text-white font-semibold rounded-full hover:bg-gray-800 transition-colors text-sm disabled:opacity-50"
          onClick={submit}
        >
          Guardar
        </button>
      </div>
    </div>
  );
};

const useForm = ({ initialData, onClose, onSuccess }) => {
  const initialSubcategory = {
    _id: '',
    failure_category_id: '',
    name: '',
    description: '',
    trigger_criteria: '',
    mileage_interval: '',
    mileage_alert: '',
    time_interval_unit: '',
    time_interval: '',
    time_alert: '',
    status: 1,
  }

  const getInitial = (data) => ({
    items: clone(data?.items || []),
  });

  const [form, setForm] = useState(() => getInitial(initialData));

  const onChange = (_id, target, value) => {
    const items = form.items.map((item, index) => {
      if (item._id === _id) {
        return { ...item, [target]: value };
      }
      return item;
    });

    setForm(s => ({ ...s, items }));
  };

  const onAdd = () => {
    setForm(s => ({ ...s, items: s.items.concat([{ ...initialSubcategory, _id: uuid() }]) }));
  }
  
  const onRemove = (index) => {
    const items = form.items.filter((_, idx) => index !== idx);
    setForm(s => ({ ...s, items }))
  }

  const isValidForm = () => {
    const onError = (msg) => {
      toast.error(msg);
      return false;
    }

    if (form.items.some(x => !x.name.trim()))
      return onError('Debe indicar el nombre de cada subcategoría');

    if (form.items.some(x => form.items.filter(y => String(y.name).toLocaleLowerCase() === String(x.name).toLocaleLowerCase())?.length > 1))
      return onError('No puede haber subcategorías duplicadas');

    return true;
  };

  const submit = async () => {
    if (!isValidForm()) return;
    onSuccess?.(form);
    onClose?.();
  };

  return {
    form,
    onAdd,
    onChange,
    onRemove,
    submit,
  };
};

export default ModalCreateSubcategory;
